<section
  *ngIf="{ formChanges: formChanges$ | async } as STATE"
  [formGroup]="form"
  class="cron-editor resource-form"
>
  <article>
    <mat-label>Programmer pour: </mat-label>
    <mat-form-field>
      <div matPrefix class="custom-prefix">
        <img src="assets/icons/calendar_grey.svg" alt="" />
      </div>
      <mat-select formControlName="occurrence">
        <mat-option [value]="cronDescriptorOccurrence.date">
          Date précise
        </mat-option>
        <mat-option [value]="cronDescriptorOccurrence.everyHour">
          Toutes les heures
        </mat-option>
        <mat-option [value]="cronDescriptorOccurrence.everyDay">
          Tous les jours
        </mat-option>
        <mat-option [value]="cronDescriptorOccurrence.everyWeek">
          Toutes les semaines
        </mat-option>
        <mat-option [value]="cronDescriptorOccurrence.everyMonth">
          Tous les mois
        </mat-option>
        <mat-option [value]="cronDescriptorOccurrence.everyYear">
          Tous les ans
        </mat-option>
      </mat-select>
      <div matSuffix class="custom-suffix">
        <img src="assets/icons/unfold-more.svg" alt="more" />
      </div>
    </mat-form-field>
  </article>

  <article *ngIf="selectedOccurrence === cronDescriptorOccurrence.date">
    <mat-label>Date</mat-label>
    <mat-form-field>
      <div matPrefix (click)="picker.open()" class="custom-prefix">
        <img src="assets/icons/calendar_grey.svg" alt="" />
      </div>
      <input
        (click)="picker.open()"
        matInput
        [value]="
          currentDate
            ? (currentDate | date: 'dd/MM/yyyy' : '' : 'fr')
            : 'Sélectionnez une date'
        "
      />
      <input
        formControlName="date"
        matInput
        class="hidden-content"
        placeholder="Sélectionnez une date"
        [matDatepicker]="picker"
      />
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </article>

  <article *ngIf="selectedOccurrence === cronDescriptorOccurrence.everyHour">
    <mat-label>Chaque: </mat-label>
    <mat-form-field>
      <div matPrefix class="custom-prefix">
        <img src="assets/icons/clock-grey.svg" alt="" />
      </div>
      <input
        matInput
        formControlName="minute"
        [min]="1"
        [max]="59"
        type="number"
        placeholder="Entrez la minute de début"
      />
      <div matSuffix class="custom-suffix">
        <span>minutes</span>
      </div>
    </mat-form-field>
  </article>

  <div
    class="cron-editor__row"
    [class.cron-editor__row--2]="
      selectedOccurrence === cronDescriptorOccurrence.everyYear
    "
  >
    <article *ngIf="selectedOccurrence === cronDescriptorOccurrence.everyYear">
      <mat-label>En: </mat-label>
      <mat-form-field>
        <div matPrefix class="custom-prefix">
          <img src="assets/icons/calendar_grey.svg" alt="" />
        </div>
        <mat-select formControlName="month" [multiple]="true">
          <mat-option [value]="1"> Janvier </mat-option>
          <mat-option [value]="2"> Février </mat-option>
          <mat-option [value]="3"> Mars </mat-option>
          <mat-option [value]="4"> Avril </mat-option>
          <mat-option [value]="5"> Mai </mat-option>
          <mat-option [value]="6"> Juin </mat-option>
          <mat-option [value]="7"> Juillet </mat-option>
          <mat-option [value]="8"> Août </mat-option>
          <mat-option [value]="9"> Septembre </mat-option>
          <mat-option [value]="10"> Octobre </mat-option>
          <mat-option [value]="11"> Novembre </mat-option>
          <mat-option [value]="12"> Décembre </mat-option>
        </mat-select>
        <div matSuffix class="custom-suffix">
          <img src="assets/icons/unfold-more.svg" alt="" />
        </div>
      </mat-form-field>
    </article>

    <article
      *ngIf="
        selectedOccurrence === cronDescriptorOccurrence.everyMonth ||
        selectedOccurrence === cronDescriptorOccurrence.everyYear
      "
    >
      <mat-label>Le: </mat-label>
      <mat-form-field>
        <div matPrefix class="custom-prefix">
          <img src="assets/icons/calendar_grey.svg" alt="" />
        </div>
        <input
          formControlName="dayOfMonth"
          matInput
          type="number"
          placeholder="Entrez le jour du mois"
          [min]="1"
          [max]="31"
        />

        <span matSuffix>du mois</span>
      </mat-form-field>
    </article>
  </div>

  <article *ngIf="selectedOccurrence === cronDescriptorOccurrence.everyWeek">
    <mat-label>Le: </mat-label>
    <mat-form-field>
      <div matPrefix class="custom-prefix">
        <img src="assets/icons/calendar_grey.svg" alt="" />
      </div>
      <mat-select [multiple]="true" formControlName="daysOfWeek">
        <mat-option [value]="1"> Lundi </mat-option>
        <mat-option [value]="2"> Mardi </mat-option>
        <mat-option [value]="3"> Mercredi </mat-option>
        <mat-option [value]="4"> Jeudi </mat-option>
        <mat-option [value]="5"> Vendredi </mat-option>
        <mat-option [value]="6"> Samedi </mat-option>
        <mat-option [value]="0"> Dimanche </mat-option>
      </mat-select>
      <div matSuffix class="custom-suffix">
        <img src="assets/icons/unfold-more.svg" alt="" />
      </div>
    </mat-form-field>
  </article>

  <div class="cron-editor__row cron-editor__row--2">
    <article
      *ngIf="
        selectedOccurrence === cronDescriptorOccurrence.everyDay ||
        selectedOccurrence === cronDescriptorOccurrence.everyWeek ||
        selectedOccurrence === cronDescriptorOccurrence.everyMonth ||
        selectedOccurrence === cronDescriptorOccurrence.everyYear ||
        selectedOccurrence === cronDescriptorOccurrence.date
      "
    >
      <mat-label>À: </mat-label>
      <mat-form-field>
        <div matPrefix class="custom-prefix">
          <img src="assets/icons/clock-grey.svg" alt="" />
        </div>
        <input
          formControlName="hour"
          matInput
          type="time"
          placeholder="Entrez l'heure de début"
        />
      </mat-form-field>
    </article>
    <ng-content></ng-content>
  </div>
</section>
